import { useEffect } from 'react';

import { getFeatureGate } from '../../../statsig/statsig-client';

const CSMChatWidget = () => {
    useEffect(() => {
        const loadScript = (url) => {
            const script = document.createElement('script');
            script.src = url;
            script.async = true; // or script.defer = true;
            script.dataset.testid = 'csm-chat-widget-script';
            document.body.append(script);
        };

        const checkAndLoadWidget = async () => {
            const widget = document.querySelector(
                '#atlassian-conversation-assistant-widget'
            );
            if (!widget) {
                if (
                    await getFeatureGate(
                        'csm-sac-use-versioned-installer',
                        false
                    )
                ) {
                    loadScript(
                        `${window.CSM_CHAT_WIDGET_BASE_URL}/installer.js`
                    );
                } else {
                    loadScript(
                        `${window.CSM_CHAT_WIDGET_BASE_URL}/assets/loader.js`
                    );
                }
            }
        };

        checkAndLoadWidget();
    }, []);
    return null;
};

export default CSMChatWidget;
